export default "__VITE_ASSET__BE2Jd8A2__"